<div class="common-layout is-default"
     [ngClass]="{
        'is-expand' : isExpand
    }"
>
  <app-header></app-header>
  <app-sidenav></app-sidenav>
  <div class="page-container">
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>

<!--<ng-template #acceptCookiesRef let-notification>
  <p class="m-b-0 text-gray">
    We use cookies to offer you a great browsing experience, analyze traffic and personalize content. If you use this
    site, you consent to our use of cookies
    <button nz-button nzSize="small" nzType="link" class="accept-cookies-btn" (click)="acceptCookies(notification)">
      GOT IT
    </button>
  </p>
</ng-template>-->
